export default {
    resalesLanding: {
        sentOn: "Elküldve",
        toggleContact: "Az iroda elérhetőségeinek megjelenítése/elrejtése",
        propertyOffers: "Ingatlanajánlatok",
        openGallery: "Fotógaléria megnyitása",
        prevPhoto: "Előző fotó",
        nextPhoto: "Következő fotó",
        close: "Bezárás",
        photo: "Fotó",
        description: "Leírás",
        more: "Több",
        less: "Kevesebb",
        intFloorSpace: "Hasznos alapterület",
        build: "Beépített terület",
        terrace: "Terasz",
        garden: "Kert",
        buildYear: "Építés éve",
        fees: "Díjak",
        communityFees: "Közös költség",
        basuraTax: "Hulladékdíj (Basura)",
        ibiFees: "IBI (ingatlanadó)",
        securityDeposit: "Kaució",
        perMonth: "/hó",
        perWeek: "/hét",
        disclaimer: "Jogi nyilatkozat",
        energyCertificate: "Energetikai tanúsítvány",
        pending: "Folyamatban",
        rating: "Besorolás",
        presentedBy: "Bemutatja",
        propertyDetails: "Ingatlan adatai",
        reference: "Hivatkozás",
        referenceShort: "Ref",
        unitUnavailable: "Már nem elérhető",
        availableUnits: "Elérhető lakások és árak",
        availableUnitsShort: "Elérhető lakások",
        unit: "Lakás",
        type: "Típus",
        floors: "Szintek",
        bedrooms: "Háló",
        bathrooms: "Fürdő",
        surfaceArea: "Belső",
        price: "Ár",
        status: "Állapot",
        unitAvailable: "Elérhető",
        unitReserved: "Foglalt",
        unitSold: "Eladva",
        seeMore: "Több megjelenítése",
        seeLess: "Kevesebb megjelenítése",
        floor: "Emelet",
        storeys: "Szintek száma",
        keyReady: "Kulcsrakész",
        touristLicence: "Turisztikai engedély",
        firstOccupationLicence: "Használatbavételi engedély",
        notKnown: "Nem ismert",
        notProvided: "Nincs megadva",
        yes: "Igen",
        no: "Nem",
        mortgageAvailable: "Hitel igényelhető",
        guaranteedRental: "Garantált bérbeadás",
        sellBeforeCompletion: "Szerződés átruházása a projekt befejezése előtt",
        sellBeforeCompletionYes: "Engedélyezett",
        sellBeforeCompletionNo: "Nem engedélyezett",
        sellBeforeCompletionNotProvided: "Nincs megadva",
        reservation: "Foglalás",
        contract: "Szerződés",
        construction: "Építés",
        completion: "Befejezés",
        co2: "CO2",
        energyConsumption: "Energiafogyasztás",
        co2PerYear: "kg CO2/év",
        kwhPerYear: "kWh/év",
        features: "Jellemzők",
        viewDetails: "Részletek megtekintése",
        hideDetails: "Ingatlan adatainak elrejtése",
        backToResults: "Találatok",
        viewProperty: "Ingatlan megtekintése",
        prevProperty: "Előző",
        nextProperty: "Következő",
        viewAllFeatures: "Összes jellemző megtekintése",
        allFeatures: "Összes jellemző",
        infoOnRequest: "Információ kérésre",
        tbc: "Nem ismert",
        featureCategoryLabels: { pool: "Medence", views: "Kilátás", parking: "Parkolás", kitchen: "Konyha", condition: "Állapot", garden: "Kert" },
        featureQualifierFormat: "{value} {category}",
        location: "Elhelyezkedés",
        agencyInformation: "Az iroda adatai",
        buyingCosts: "Vásárlási költségek",
        propertyPrice: "Ingatlan ára:",
        priceNote: "**Az ár nem tartalmazza az adókat és a vásárlási költségeket.",
        estimatedPurchaseCosts: "Becsült vásárlási költségek:",
        hide: "Elrejtés",
        showBreakdown: "Vásárlási költségek részletezése",
        purchaseCostBreakdown: "Vásárlási költségek részletezése",
        concept: "Tétel",
        application: "Alkalmazás",
        rowTransferTax: "ITP (vagyonátruházási illeték, használt ingatlan)",
        rowVat: "ÁFA (új építésű)",
        rowVatLand: "ÁFA",
        vatApplication: "10% (4% támogatott lakás esetén)",
        rowStampDuty: "Okirati illeték (AJD)",
        rowNotary: "Közjegyző",
        rowLandRegistry: "Ingatlan-nyilvántartás",
        officialTariff: "Hivatalos díjszabás",
        costRangeNotePrefix: "*A vevő teljes költsége jellemzően",
        and: "és",
        ofPurchasePrice: "a vételár között mozog.",
        costApproxNote: "*A becsült vásárlási költségek csak tájékoztató jellegűek. A tényleges költségek az ingatlantól és a vevő körülményeitől függően eltérhetnek. Pontos számításhoz javasoljuk szakértői tanácsadás igénybevételét.",
        additionalInformation: "További információk",
        addInfoDocument: "*Rövidített tájékoztató dokumentum elérhető a 218/2005. számú andalúziai rendelet szerint",
        addInfoNoFees: "*A vevő nem fizet ingatlanközvetítői díjat",
        formHeading: "Szeretne többet megtudni az árakról és az ingatlanról?",
        firstName: "Keresztnév",
        enterNumber: "Adja meg a számot",
        email: "E-mail",
        searchCountry: "Ország vagy hívószám keresése",
        noMatches: "Nincs találat",
        consent: "A gombra kattintva hozzájárul személyes adatainak az adatvédelmi szabályzat szerinti kezeléséhez, ideértve a megadott adatok gyűjtését, tárolását és felhasználását annak érdekében, hogy kapcsolatba lépjünk Önnel és megadjuk a szükséges információkat.",
        send: "Küldés",
        contactUs: "Kapcsolat",
        yourMessage: "Az Ön üzenete",
        agreeData: "Hozzájárulok adataim megadásához annak érdekében, hogy választ kapjak információkérésemre.",
        agreeContact: "Kérem a tájékoztatást, és hozzájárulok ahhoz, hogy a beruházásért felelős vállalat vagy az érintett forgalmazó kapcsolatba lépjen velem az e célból önként megadott elérhetőségeimen.",
        reject: "Elutasítás",
        like: "Tetszik",
        liked: "Elmentve",
        rejected: "Elutasítva",
        offerRejected: "Ajánlat elutasítva",
        contact: "Kapcsolat",
        call: "Hívás",
        calling: "Hívás",
        noPhone: "Nincs elérhető telefonszám",
        enquirySent: "Megkeresés elküldve — felvesszük a kapcsolatot",
        yourDetails: "az Ön adatai",
        respondedTo: "megválaszolva",
        noProperties: "Nincs megjeleníthető ingatlan.",
        soldOutBody: "Az ajánlatban szereplő ingatlanokat eladták, vagy már nincsenek a piacon. Frissített válogatásért forduljon az ügynökséghez.",
        expiredTitle: "Ez az ajánlati link lejárt",
        expiredBody: "Kérjük, forduljon az irodához friss linkért az ingatlanok megtekintéséhez.",
        unavailableTitle: "Az ajánlat nem érhető el",
        unavailableBody: "Nem sikerült betölteni ezt az ajánlatot. Előfordulhat, hogy a link érvénytelen, vagy a szolgáltatás átmenetileg nem elérhető — kérjük, próbálja meg később, vagy forduljon az irodához.",
    },
    title: "{agencyName} tulajdonságai",
    in: "itt",
    propertiesFound: "tulajdonságok találhatók",
    toDay: "Ma",
    days: "napok",
    week: "Hét",
    year: "Év",
    month: "Hónap",
    prev: "Előző",
    next: "Következő",
    backToList: "Vissza a listához",
    sorry: "Sajnáljuk, mi",
    cantFind: "nem találom",
    lookingFor: "a keresett oldal ...",
    thankYou: "KÖSZÖNJÜK, HOGY LÁTOGATTAK OLDALUNKAT",
    pleaseContact: "Kérjük, vegye fel a kapcsolatot az ügynökkel új URL-címért.",
    ForSale: "AKCIÓ",
    ShortTermRental: "Rövid bérlet",
    LongTermRental: "Long Rent",
    showMore: "Show More",
    showLess: "Kevesebbet mutat",
    price: "Ár",
    pricePer: "Ár per",
    built: "Épít",
    floorSpace: "Int. alapterület",
    terrace: "Terasz",
    garden: "kert",
    plot: "telek",
    propTitle: '{subType} {searchType} itt {location}',
    propTitleShort: '{subType} itt {location}',
    notAvailable: "Nem érhetőek el",
    notFound: 'Az oldal nem található',
    emptyProperties: "Ominaisuuksia ei löytynyt, ota yhteyttä edustajaasi saadaksesi lisätietoja.",
    linkExpired: "Hoppá, ez a link lejárt. Vegye fel a kapcsolatot ingatlanügynökkel, hogy megkapja a frissített ingatlan linket.",
    newDevelopment: "Új fejlesztés",
    agencyRaiiNo: "Az Ügynökség nyilvántartási száma",
    home: {
        verifyYourURLHere: "Itt ellenőrizze az URL-t. Ehhez jelentkezzen be a WhatsApp-ra a webböngészőjében, majd másolja az URL-t a WhatsApp-ból ide.",
        pasteUrlHere: "Illessze ide az URL-t",
        verifyUrl: "URL igazolása",
        whatIsPropertyViewer: "Mi az a Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Az ingatlanközvetítők ezt a weboldalt használják ingatlanok elküldéséhez ügyfeleiknek. Ez a {resalesonlinecom} terméke. Ha kétségei vannak, kérjük, beszéljen a az ügynök, aki elküldte neked az ingatlanlistád.",
        howDoesItWork: "Hogyan működik?",
        inThePast: "A múltban az ügynökök PDF dokumentumokat küldtek ügyfeleiknek. Ezek azonban nem könnyű megtekinteni sok eszközön. Ezért létrehoztuk {propertyviewercom}, hogy az ügyfél könnyebben megtekinthesse a nekik küldött tulajdonságokat.",
        createAShortList: "Az ügynök létrehoz egy rövid listát a tulajdonságokról. Amikor megosztják önnel ezeket a tulajdonságokat, kap egy linket. Erre a linkre kattintva megmutatja a tulajdonságokat."
    },

    list: {
        propertyTitle: "Kattintson ide a tulajdonság adatainak megtekintéséhez"
    },

    searchType: {
        ForSale: "eladó",
        ShortTermRental: "rövid távra kiadó",
        LongTermRental: "hosszú távra kiadó",
    },

    rsStatus: {
        Available: "Beszerezhető",
        Listing: "Szövetszegély",
        UnderOffer: "Az ajánlat alatt",
        SaleAgreed: "Eladás megállapodott",
        OffMarket: "Piacon kívül",
        Sold: "Eladott",
        Rented: "Bérelt"
    },

    details: {
        average: "Átlagos",
        averagePricesFor: "Átlagos árak",
        showFullER: "Teljes megjelenítése",
        thisProperty: "Ez a tulajdonság",
        infoNotAvailable: "Ez az információ nem áll rendelkezésre.",
        feesEnergyRating: "Díjak, energiaminősítés",
        fees: "Díjak",
        ibiFees: "IBI díjak",
        basuraTax: "Basura adó",
        communityFees: "Közösségi díjak",
        associatedCosts: "Kapcsolódó költségek",
        energyRating: "Energetikai besorolás",
        securityDeposit: "Kaució",
        energyCertificate: "Energiatanúsítvány",
        energyCertificatePending: "Az energiatanúsítvány függőben van",
        energyConsumption: "Energiafogyasztás",
        co2: "CO₂",
        co2PerYear: "kgCO₂ / m² / év",
        kwhPerYear: "kWh / m² / év",
        other: "Mások",
        buildYear: "Építési év",
        forSale: "Eladó",
        sold: "Eladva",
        longTerm: "hosszú távú",
        shortTermHigh: "Rövid távon magas",
        shortTermLow: "Rövid távon alacsony",
        allFeatures: "Minden szolgáltatás",
        aproxLocation: "Aprox. Hely",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Turisztikai regisztrációs szám",
        agencyInformation: "Ügynökségi információk",
    },
};